import blogPage from "./blogPage";

blogPage._renderBlog();
